import React, { memo } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { DsButton, DsIcon } from "../../design-system";

const Pagination = memo(function Pagination({
  currentPage,
  totalPages,
  onPageChange,
  itemsPerPage,
  onItemsPerPageChange: _onItemsPerPageChange,
  darkMode = false,
  className = "",
}) {
  return (
    <div
      className={`flex flex-wrap items-center justify-between gap-2 border-t border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-surface))] px-3 py-2 ${className}`}
    >
      <div className="min-w-0 flex-1 ds-body text-[hsl(var(--ds-muted-fg))]" />

      <div className="flex flex-wrap items-center justify-end gap-1">
        <DsButton
          type="button"
          variant="outline"
          size="sm"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          aria-label="Previous page"
          className="!px-2"
        >
          <DsIcon icon={ChevronLeft} size="md" />
        </DsButton>

        <div className="flex items-center gap-1">
          {itemsPerPage === "all" ? (
            <DsButton
              type="button"
              size="sm"
              variant={currentPage === 1 ? "primary" : "outline"}
              onClick={() => onPageChange(1)}
              className="!min-w-[32px]"
            >
              1
            </DsButton>
          ) : (
            Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
              let pageNum;
              if (totalPages <= 5) {
                pageNum = i + 1;
              } else if (currentPage <= 3) {
                pageNum = i + 1;
              } else if (currentPage >= totalPages - 2) {
                pageNum = totalPages - 4 + i;
              } else {
                pageNum = currentPage - 2 + i;
              }

              return (
                <DsButton
                  type="button"
                  key={pageNum}
                  size="sm"
                  variant={currentPage === pageNum ? "primary" : "outline"}
                  onClick={() => onPageChange(pageNum)}
                  className="!min-w-[32px]"
                >
                  {pageNum}
                </DsButton>
              );
            })
          )}
        </div>

        <DsButton
          type="button"
          variant="outline"
          size="sm"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          aria-label="Next page"
          className="!px-2"
        >
          <DsIcon icon={ChevronRight} size="md" />
        </DsButton>
      </div>
    </div>
  );
});

export default Pagination;
